<template>
   <div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
     <div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-6 leading-8 text-center">
       <div class="flex w-full justify-center text-ihh-midnight-gray font-semibold text-3xl text-center">
          Birth Pool Setup and Use Best Practices
       </div>
       <div class="flex w-full justify-center text-ihh-slate-gray font-semibold text-base text-center">
          Birth Pool Setup and Use Best Practices
       </div>
       <div class="flex w-full justify-center text-ihh-slate-gray font-semibold text-xl text-center">
          Coming Soon
       </div>
     </div>
   </div>
</template>
